<script setup lang="ts">
  import { useMatrixFillLabContext } from '../../model/useMatrixFillLab';
  import LabSection from './LabSection.vue';
  import ReportTable from './ReportTable.vue';

  const lab = useMatrixFillLabContext();
</script>

<template>
  <LabSection
    title="Relatório"
    open
    data-testid="lab-report"
    :badge="`${lab.responses.value.length} resposta(s)`"
    hint="A tela de relatório: uma linha por resposta salva, com uma coluna por campo."
  >
    <ReportTable />
  </LabSection>
</template>
